import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { fade } from '../../shared/styles';

export const Wrapper = styled.nav`
	z-index: 2;
	width: 100%;
	height: 10dvh;
	background-color: ${({ theme }) => theme.main};
	margin: 0;

	display: flex;
	flex-direction: row;

	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	animation: 2s ease 0s normal forwards 1 ${fade};
	transition: all 0.5s ease;
`;

export const Logo = styled.nav`
	height: 100%;
	width: 100%;
	flex: 1;

	display: flex;
	justify-content: center;
	align-items: center;
`;

export const StyledLink = styled(NavLink)`
	text-decoration: none;
	color: ${({ theme }) => theme.text.main};

	margin: 2vh 0;

	&:hover,
	&:focus {
		color: ${({ theme }) => theme.text.hover};
	}

	&.active {
		color: ${({ theme }) => theme.text.active};
	}

	@media (min-width: 768px) {
		flex: 1;
		margin: 0 2vw;
	}
`;

export const Navbar = styled.nav`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-transform: lowercase;
	font-size: 1.5rem;

	/* mobile: full-screen panel that slides in from the right */
	position: fixed;
	inset: 0;
	background-color: ${({ theme }) => theme.main};
	transform: translateX(${(props) => (props.open ? '0' : '100%')});
	/* hidden when closed so its links can't be tabbed to */
	visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
	transition: transform 0.4s ease, visibility 0.4s;

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}

	@media (min-width: 768px) {
		flex-direction: row;
		height: 100%;
		width: fit-content;
		font-size: 1rem;
		position: static;
		background-color: transparent;
		transform: none;
		visibility: visible;
		transition: none;
	}
`;

export const HamburgerMenu = styled.button`
	position: absolute;
	top: 1rem;
	right: 1rem;
	z-index: 1; /* above the slide-in panel */
	background-color: transparent;
	border: none;
	cursor: pointer;
	-webkit-user-select: none; /* Safari */
	-ms-user-select: none; /* IE 10 and IE 11 */
	user-select: none; /* Standard syntax */

	@media (min-width: 768px) {
		display: none;
	}
`;
